export const TARGET_GROUPS: Record<string, string[]> = {
    '191': ['21', '191'], // N. Pakistan
    '110': ['110', '213'], // E. Utah
    '68': ['2', '68'], // Pennsylvania & Ohio
    '11': ['11', '65'], // Coastal Turkmenistan
    '347': ['80', '347', '380'] // Bangladesh
};

const makeTargetGroupLookupByChild = () => {
    const result: Record<string, string> = {};
    Object.entries(TARGET_GROUPS).forEach(([groupId, memberIds]) => {
        memberIds.forEach((memberId) => {
            result[memberId] = groupId;
        });
    });
    return result;
};

export const TARGET_GROUP_LOOKUP_BY_CHILD = makeTargetGroupLookupByChild();
